import { useLocation } from "react-router-dom";
import AdSenseUnit from "@/components/ads/AdSenseUnit";
import { AD_SLOTS } from "@/config/adSlots";
import { AD_LABEL, getAdContainerClass, isAdsenseAllowedPath } from "@/lib/adsensePolicy";

export default function InFeedAd({ className = "" }) {
  const location = useLocation();
  if (!isAdsenseAllowedPath(location.pathname, location.search)) return null;

  return (
    <aside aria-label={AD_LABEL} className={getAdContainerClass(className)}>
      <div className="mb-1 text-center text-[11px] uppercase tracking-wide text-muted-foreground/70">{AD_LABEL}</div>
      <AdSenseUnit slot={AD_SLOTS.inFeed} format="fluid" layoutKey="-g3-u-1i-f0+uf" style={{ display: "block", minHeight: 200 }} />
    </aside>
  );
}